import { FloatButton } from 'antd';
import styled from 'styled-components';

export default styled(FloatButton)`
	// Add your styles here
`;
